import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sos',
  templateUrl: './sos.component.html',
  styleUrls: ['./sos.component.css']
})
export class SosComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  public openLink() {
    this.router.navigate(["/sos-screen"]);
  }
}
